import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import styles from './CommoditiesAddTemplate.module.css';
import cn from 'classnames';
import { Label } from '../../atoms';
import { Button, Container } from 'react-bootstrap';
import { CommoditiesAddOrganism, TranslationOrganism } from '../../organisms';
import { useNavigate } from 'react-router-dom';
import { NonRecursiveCommodityResponseDto } from '../../../store/tradeAPI/commodity/dto/response/non-recursive-commodity-response.dto';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

export interface CommoditiesAddTemplateProps {
  handleSubmit: (commodity: NonRecursiveCommodityResponseDto) => void;
  commodity: NonRecursiveCommodityResponseDto;
  handleOnChange: (commodity: NonRecursiveCommodityResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const CommoditiesAddTemplate: FC<CommoditiesAddTemplateProps> = ({
  handleSubmit,
  commodity,
  handleOnChange,
  handleImageOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Commodity" size="lg" />
          <Button
            className={styles.buttonLink}
            onClick={() => navigate('/commodities')}
            variant="link"
          >
            Go back to overview
          </Button>
        </div>
        <TranslationOrganism
          setLanguage={setLanguage}
          selectedLanguage={selectedLanguage}
          fromLanguage={fromLanguage}
          setFromLanguage={setFromLanguage}
          toLanguage={toLanguage}
          setToLanguage={setToLanguage}
          generateTranslation={generateTranslation}
          generateAllTranslations={generateAllTranslations}
        />
        <div className={cn(styles.commoditiesAddOrganismWrapper)}>
          <CommoditiesAddOrganism
            handleSubmit={handleSubmit}
            commodity={commodity}
            handleOnChange={handleOnChange}
            handleImageOnChange={handleImageOnChange}
          />
        </div>
      </Container>
    </BaseTemplate>
  );
};

export default CommoditiesAddTemplate;
